import { Users } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiError, api } from '../../api';
import { useAuth } from '../../auth-context';
import { t } from '../../i18n';
import type { ChildPublic } from '../../types';
import { AppShell } from '../shared/AppShell';
import { Avatar } from '../shared/Avatar';

export function ProfileSelector() {
  const [children, setChildren] = useState<ChildPublic[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { state } = useAuth();

  useEffect(() => {
    if (state.status === 'child') navigate('/child', { replace: true });
    else if (state.status === 'parent') navigate('/parent', { replace: true });
  }, [state.status, navigate]);

  useEffect(() => {
    api
      .childrenList()
      .then((res) => setChildren(res.children))
      .catch((err) => {
        setError(err instanceof ApiError ? err.message : t('common.error.network'));
      });
  }, []);

  return (
    <AppShell>
      <main className="mx-auto flex min-h-dvh max-w-md flex-col justify-center gap-6 p-6">
        <div className="flex flex-col gap-3">
          {children === null ? (
            <p className="text-center text-ink-muted text-[14px]">{t('common.loading')}</p>
          ) : (
            children.map((c) => (
              <button
                key={c.id}
                onClick={() => navigate(`/login/child/${c.id}`)}
                className={[
                  'ramp-' + c.color_ramp,
                  'flex h-[140px] w-full items-center justify-center gap-4 rounded-xl bg-child-fill p-5 text-child-text transition active:scale-[0.99]',
                ].join(' ')}
              >
                <Avatar
                  initial={c.avatar_initial}
                  ramp={c.color_ramp}
                  size="xl"
                  src={c.avatar_url ?? undefined}
                />
                <div className="text-left">
                  <div className="text-[18px] font-medium">{c.name}</div>
                </div>
              </button>
            ))
          )}
          {error ? <p className="text-center text-[12px] text-danger">{error}</p> : null}
        </div>
        <button
          onClick={() => navigate('/login/parent')}
          className="mx-auto flex h-[50px] w-[120px] items-center justify-center gap-2 rounded-md bg-surface-muted text-[14px] text-ink-muted transition active:scale-[0.98]"
        >
          <Users size={16} />
          {t('selector.parent')}
        </button>
      </main>
    </AppShell>
  );
}
